import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, QueryList, ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormRichFieldConfig} from '../../../../model/api/form-rich-field-config';
import {CcSubFormBaseComponent} from "../cc-sub-form-base.component";

@Component({
  selector: 'cc-add-delete-field[formRichFieldConfig][formRecords]',
  templateUrl: './add-delete-field.component.html',
  styleUrls: ['./add-delete-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddDeleteFieldComponent extends CcSubFormBaseComponent {

  fieldValueMap = {};

  @Input()
  formRichFieldConfig: FormRichFieldConfig;

  @Input()
  formRecords: any[];
  @Output()
  formRecordsChange = new EventEmitter<any[]>();

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Input()
  transPartKey: string;

  submitted: boolean;

  @ViewChildren('ccSubForm')
  subFormComponents: QueryList<CcSubFormBaseComponent>;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  ngAfterContentInit() {
    super.ngAfterContentInit();
    this.reloadFieldValueMap();
  }

  delete(index: number) {
    this.formRecords.splice(index, 1);
  }

  public reloadFieldValueMap(): void {
    // setTimeout(() => {
    if (this.formRichFieldConfig && this.formRecords) {
      if (this.formRichFieldConfig.canDelete)
        this.fieldValueMap['canDelete'] = this.formRichFieldConfig.canDelete(this.formRecords);
      if (this.formRichFieldConfig.canAdd)
        this.fieldValueMap['canAdd'] = this.formRichFieldConfig.canAdd(this.formRecords);

      this.formRecords.forEach((value, recordIndex) => {
        // if (this.formRichFieldConfig.style)
        //   this.fieldValueMap['style-' + recordIndex] =
        //     this.formRichFieldConfig.style(value);
        if (this.formRichFieldConfig.class)
          this.fieldValueMap['class-' + recordIndex] =
            this.formRichFieldConfig.class(value);
        // this.formRichFieldConfig.fields.forEach((groupConf, groupIndex) => {
        //   if (groupConf.hidden)
        //     this.fieldValueMap['hiddenGroup-' + groupIndex + '_' + recordIndex] = groupConf.hidden(value);
        //   groupConf.fields.forEach((fieldConf, fieldIndex) => {
        //     if (fieldConf.hidden)
        //       this.fieldValueMap['hiddenField-' + groupIndex + '_' + fieldIndex + '_' + recordIndex] = fieldConf.hidden(value);
        //   });
      });
      if (this.subFormComponents)
        this.subFormComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
      super.reloadFieldValueMap();
    }
    // });
  }
}

